import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, X } from 'lucide-react';

const KEY = 'vf_return_to';

// Floating "back to the lecture resources" pill, shown after opening an internal tool from a lecture.
export const ReturnToLecture = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [ret, setRet] = useState(null);
  useEffect(() => {
    try { setRet(JSON.parse(sessionStorage.getItem(KEY))); } catch { setRet(null); }
  }, [pathname]);
  if (!ret || pathname === ret.to.split('#')[0]) return null;
  const clear = () => { sessionStorage.removeItem(KEY); setRet(null); };
  return (
    <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[150] flex items-center gap-1 rounded-full bg-[#060d24] text-white shadow-2xl border border-white/10 pl-1 pr-1 py-1" data-testid="return-to-lecture">
      <button onClick={() => { clear(); navigate(ret.to); }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-600 hover:bg-blue-500 text-sm font-bold transition-colors" data-testid="return-to-lecture-btn">
        <ArrowLeft className="w-4 h-4" />{ret.label || 'Torna alle risorse'}
      </button>
      <button onClick={clear} className="p-2 rounded-full hover:bg-white/10" aria-label="close" data-testid="return-to-lecture-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
};
